<mat-toolbar [ngClass]="{ 'sidenav-open': isSidenavOpen }">
  <header class="gap-container full">
    <a
      class="content-left"
      [routerLink]="basePath === 'firm' ? ['/'+basePath+'/cases'] : ['/'+basePath+'/home']"
      *ngIf="settingsService.settings"
    >
      <img
        [src]="'assets/img/mdr-Logo.svg'"
        alt="Mishcon de Reya"
      />
    </a>
    <!-- <app-search-input></app-search-input> -->
    <div class="content-right">
      <ng-container *ngIf="showLanguageSelector">
        <!-- desktop button -->
        <button
          class="btn-language-menu flex justify-content-space-between"
          mat-stroked-button
          [matMenuTriggerFor]="languageMenu"
        >
          <div class="flex align-itens-center justify-content-center">
            <mat-icon class="icon-language">language</mat-icon>
            {{ languageText }}
          </div>
          <mat-icon class="icon-dropdown">arrow_drop_down</mat-icon>
        </button>

        <!-- mobile button -->
        <button
          mat-icon-button
          [matMenuTriggerFor]="languageMenu"
          class="mobile-btn-language-menu"
        >
          <mat-icon class="icon-language">language</mat-icon>
        </button>

        <mat-menu #languageMenu="matMenu">
          <button
            mat-menu-item
            class="option-language-menu"
            *ngFor="let option of languageOptions"
            (click)="changeLanguage(option)"
          >
            <mat-icon
              [style.visibility]="
                language === option.value ? 'visible' : 'hidden'
              "
              >check</mat-icon
            >
            {{ option.text }}
          </button>
        </mat-menu>
      </ng-container>

      <!-- <button
        mat-icon-button
        id="notification"
        class="btn-notification"
        aria-label="Notifications"
        [matMenuTriggerFor]="menu"
      >
        <div>
          <span
            *ngIf="notifications && notifications.length > 0"
            class="circle-topic"
          ></span>
          <img
            id="notification-img"
            src="assets/icons/bell.svg"
            alt="Notifications"
          />
        </div>
      </button> -->

      <a [routerLink]="navLocked ? null : ['/' + basePath + '/profile']" [class.disabled]="navLocked" class="btn-profile" data-testid="toolbar-profile-avatar">
        <div class="profile-avatar">
          <span class="profile-name" *ngIf="!profileImg">
            {{ profileName }}
          </span>
          <img
            *ngIf="profileImg"
            class="img-circle"
            [src]="profileImg"
            alt="Profile"
          />
        </div>
      </a>

      <app-button-toggle-menu
        *ngIf="!hideMenuButton"
        [isSideNavOpen]="isSidenavOpen"
        (click)="toggleSideNav()"
        color="#1A1E1F"
      >
      </app-button-toggle-menu>
    </div>
  </header>
</mat-toolbar>

<mat-menu #menu="matMenu" class="men">
  <button
    mat-menu-item=""
    *ngFor="let note of notifications"
    routerLink="/{{ basePath }}/messages/chat/{{ note.id }}"
    [class.highlight]="
      note.cp_message &&
      note.cp_message![note.cp_message!.length - 1].user_reads &&
      note.cp_message![note.cp_message!.length - 1].user_reads!.length === 0
    "
  >
    <div class="btn-content">
      <div class="icont">
        <span
          *ngIf="
            note.cp_message &&
            note.cp_message![note.cp_message!.length - 1].user_reads &&
            note.cp_message![note.cp_message!.length - 1].user_reads!.length ===
              0
          "
          class="circle-topic"
        ></span>
        <mat-icon>chat_bubble</mat-icon>
      </div>
      <div class="text">
        <h6>{{ note.subject }}</h6>
        <p *ngIf="!!note.cp_message">
          {{ note.cp_message![note.cp_message!.length - 1].value }}
        </p>
      </div>
    </div>
    <span></span>
  </button>
  <button mat-menu-item="" *ngIf="notifications?.length == 0">
    {{ "All set. You have no new notifications." | translate }}
  </button>
</mat-menu>
